// @ts-nocheck
import React from "react";
import {
  Accordion,
  Alert,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { ExpandMore } from "@mui/icons-material";
import { Box } from "@mui/system";
import { CustomInput } from "../Custom/Input";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { alertDialogAciton } from "../../store/actions/auth";
import { useSelector } from "react-redux";
import { addLogAction } from "../../store/actions/logs";
import { Delete } from "@mui/icons-material";
import {
  addNonTaxableChargeByAdminAction,
  addReimbursementByAdminAction,
  getAllAdjustmentOfEventAction,
  getDeductionCategoriesAction,
  getNonTaxableCategoriesAction,
  getReimbursementCategoriesAction,
  removeReimbursementAndDeductionCategoriesAction,
  removeReimbursementOrDeductionAction,
} from "../../store/actions/event/adjustments";
import { CustomIconButton } from "../Custom/CustomIconButton";
import { ADJUSTMENT_TYPES } from "../../appCalcutions";
import { ExpenseReimbursementFields, emptyExpenseReimbursement } from "./ExpenseReimbursementFields";
import { apiRequest } from "../../services/apiService";
import { updatePOUpdateNeededAction } from "../../store/actions/eventRequestDetails";
import { CustomDatePicker } from "../Custom/DatePicker";
import ExpenseReceiptManager from "./ExpenseReceiptManager";

export default function NonTaxableAcc({
  user,
  data,
  expanded,
  handleAccChange,
  eventId,
  setData,
  isEditable,
  status,
  index,
}) {
  const { userId, userRole, userName } = useSelector((state) => state.auth);
  const { nonTaxableCategories, ntLoading } = useSelector(
    (state) => state?.adjustmentsReducer,
  );

  const dispatch = useDispatch();
  const requestId = React.useRef(crypto.randomUUID());
  const [reimbursement, setReimbursement] = React.useState(emptyExpenseReimbursement);
  const [reimbursementError, setReimbursementError] = React.useState("");
  const [savingReimbursement, setSavingReimbursement] = React.useState(false);
  const [savedReimbursement, setSavedReimbursement] = React.useState(null);
  const [savedCharge, setSavedCharge] = React.useState(null);
  const [editingCharge, setEditingCharge] = React.useState(false);
  const [savingCharge, setSavingCharge] = React.useState(false);
  const [chargeError, setChargeError] = React.useState("");
  const chargeFieldsEditable = data?._id ? editingCharge && !savingCharge : isEditable;
  const canManageReimbursement = user === "admin" && ["admin", "superadmin"].includes(String(userRole).toLowerCase().replace(/\s/g, ""));
  const storedReimbursement = savedReimbursement || data;
  const reimbursementChanged = !!storedReimbursement?.reimburseTechnician !== reimbursement.reimburseTechnician ||
    (reimbursement.reimburseTechnician && (String(storedReimbursement?.reimbursementContractorId || "") !== reimbursement.reimbursementContractorId ||
      Number(storedReimbursement?.reimbursementAmount || 0) !== Number(reimbursement.reimbursementAmount)));
  const reimbursementPayload = () => ({
    reimburseTechnician: reimbursement.reimburseTechnician,
    reimbursementContractorId: reimbursement.reimburseTechnician ? reimbursement.reimbursementContractorId : null,
    reimbursementAmount: reimbursement.reimburseTechnician ? Number(reimbursement.reimbursementAmount) : null,
  });
  function validateReimbursement() {
    const valid = !reimbursement.reimburseTechnician ||
      (reimbursement.reimbursementContractorId && Number(reimbursement.reimbursementAmount) > 0);
    setReimbursementError(valid ? "" : "Select a technician and enter a positive reimbursement amount.");
    return valid;
  }
  function markPoChanged() {
    [data?.reimbursementContractorId, reimbursement.reimbursementContractorId].filter(Boolean).forEach(contractorId =>
      dispatch(updatePOUpdateNeededAction({ payload: { contractorId } })),
    );
  }
  async function saveReimbursement() {
    if (!validateReimbursement() || savingReimbursement || editingCharge || savingCharge) return;
    setSavingReimbursement(true); setReimbursementError("");
    try {
      const { response, error } = await apiRequest({ method: "PUT", url: "billable-expenses/reimbursement", isToken: true,
        params: { eventId, chargeId: data._id }, data: { ...reimbursementPayload(), expectedRevision: savedReimbursement?.reimbursementRevision ?? data.reimbursementRevision ?? 0 } });
      if (response?.status !== 200) throw new Error(error?.response?.data?.message || "Unable to save reimbursement");
      setSavedReimbursement(response.data.data); markPoChanged(); refreshList();
      dispatch(alertDialogAciton({ open: true, title: "Success", message: response.data.message }));
    } catch (error) { setReimbursementError(error.message || "Unable to save reimbursement"); }
    finally { setSavingReimbursement(false); }
  }

  async function saveCharge(values) {
    if (savingCharge) return;
    setSavingCharge(true); setChargeError("");
    try {
      const { response, error } = await apiRequest({ method: "PUT", url: "billable-expenses/charge", isToken: true,
        params: { eventId, chargeId: data._id }, data: {
          nonTaxableCategoryType: values.nonTaxableCategoryType,
          nonTaxableAmount: Number(values.nonTaxableAmount),
          nonTaxableDate: values.nonTaxableDate || null,
          nonTaxableNotes: values.nonTaxableNotes || "",
          expectedChargeRevision: savedCharge?.chargeRevision ?? data.chargeRevision ?? 0,
        } });
      if (response?.status !== 200) throw new Error(error?.response?.data?.message || "Unable to save client charge");
      setSavedCharge(response.data.data); setEditingCharge(false);
      formik.resetForm({ values: { ...initialValues, ...Object.fromEntries(Object.keys(initialValues).map(key => [key, response.data.data[key] ?? initialValues[key]])) } });
      refreshList();
      dispatch(alertDialogAciton({ open: true, title: "Success", message: response.data.message }));
    } catch (error) { setChargeError(error.message || "Unable to save client charge"); }
    finally { setSavingCharge(false); }
  }

  function refreshList() {
    dispatch(
      getAllAdjustmentOfEventAction({
        payload: { params: { eventId } },
      }),
    );
    dispatch(getNonTaxableCategoriesAction({}));
  }

  const initialValues = {
    nonTaxableCategoryType: "",
    nonTaxableAmount: 0.0,
    deductionFromClientInvoice: false,
    nonTaxableNotes: "",
    nonTaxableDate: null,
  };

  const validationSchema = Yup.object().shape({
    nonTaxableCategoryType: Yup.string().trim().max(150, "Category is required (maximum 150 characters)")
      .required("Category is required (maximum 150 characters)"),
    nonTaxableAmount: Yup.number().typeError("Client charge amount must be a positive amount with at most two decimal places")
      .required("Client charge amount must be a positive amount with at most two decimal places")
      .test("clientMoney", "Client charge amount must be a positive amount with at most two decimal places", value =>
        Number.isFinite(value) && value > 0 && value <= 10000000 && Math.abs(value * 100 - Math.round(value * 100)) < 0.00001),
    deductionFromClientInvoice: Yup.boolean(),
    nonTaxableDate: Yup.date().typeError("Valid expense date required").optional().nullable(),
    nonTaxableNotes: Yup.string().trim().max(150, "Notes must be at most 150 characters").nullable(true)
      .transform((value, originalValue) => typeof originalValue === "string" && originalValue.trim() === "" ? null : value),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      if (data?._id) return saveCharge(values);
      if (!validateReimbursement()) return;
      // NOTE: do the api call to push it
      const details = {
        eventId,
      };
      dispatch(
        addNonTaxableChargeByAdminAction({
          payload: {
            data: { ...values, ...reimbursementPayload(), requestId: requestId.current },
            params: {
              // eventid and contractor id here
              eventId,
            },
          },
          successCallback: (data) => {
            if (reimbursement.reimburseTechnician) markPoChanged();
            requestId.current = crypto.randomUUID();
            refreshList();
            dispatch(
              addLogAction({
                id: details?.eventId,
                payload: {
                  actionById: userId,
                  description: `Admin ${userName} created a non taxable charges of $${values?.nonTaxableAmount} for ${values?.nonTaxableCategoryType}.`,
                },
                successCallback: () => {
                  // TODO: fetch event logs
                  // The adjustment refresh above also refreshes the charge list.
                },
              }),
            );
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message:
                  data || "Non Taxable Charges has been submitted successfully",
              }),
            );
          },
          failureCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: msg || "Failed to submit the non taxable charges.",
              }),
            );
          },
        }),
      );
    },
  });

  const { values, handleChange, touched, errors, handleBlur, submitForm } =
    formik;

  React.useEffect(() => {
    setSavedCharge(null); setEditingCharge(false); setChargeError("");
    formik.resetForm({ values: data?.newValues ? initialValues : {
      ...initialValues,
      nonTaxableCategoryType: data?.nonTaxableCategoryType || "",
      nonTaxableAmount: data?.nonTaxableAmount || 0,
      nonTaxableNotes: data?.nonTaxableNotes || "",
      nonTaxableDate: data?.nonTaxableDate || null,
    } });
  }, [data?._id, data?.chargeRevision]);

  React.useEffect(() => {
    setSavedReimbursement(null);
    setReimbursement({
      reimburseTechnician: data?.reimburseTechnician === true,
      reimbursementContractorId: data?.reimbursementContractorId || "",
      reimbursementAmount: data?.reimbursementAmount ?? "",
    });
    setReimbursementError("");
  }, [data?._id, data?.reimbursementRevision]);

  const getColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "white";
      // case "pending":
      //   return "#4D4D4D";
      // case "accepted":
      //   return "#02493E";
      // case "rejected":
      //   return "#371414";

      default:
        return "#02493E";
    }
  };

  const getTextColorOfStatus = (status) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "black";
      // case "pending":
      //   return "white";
      // case "accepted":
      //   return "#07EEC5";
      // case "rejected":
      //   return "#FF4B4B";

      default:
        return "#07EEC5";
    }
  };

  return (
    <>
      <Accordion
        sx={{
          borderRadius: "8px",
          backgroundColor: "transparent",
          width: "100%",
        }}
        expanded={expanded === `panel${index}`}
        onChange={handleAccChange(`panel${index}`)}
      >
        <AccordionSummary
          sx={{
            backgroundColor: "rgba(100, 100, 100, 0.4)",
            border: `1px solid ${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
            borderRadius: "8px",
            "& p": {
              fontSize: "1.2rem",
            },

            "@media(max-width: 600px)": {
              fontSize: "1rem",
            },
          }}
          expandIcon={<ExpandMore sx={{ color: "white" }} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0 }}>
            {values?.nonTaxableCategoryType || ""}
          </Typography>
          <Typography sx={{ color: "white", WebkitLineClamp: 1, width: "43%" }}>
            {values?.nonTaxableDate
              ? dayjs(values?.nonTaxableDate).format("MM-DD-YYYY") ||
                "Date of Expense"
              : ""}
          </Typography>
          <Typography
            sx={{
              color: getTextColorOfStatus(status),
              border: `1px solid ${getColorOfStatus(status)}`,
              backgroundColor: getColorOfStatus(status),
              padding: "0.2rem",
              borderRadius: "8px",
              minWidth: "23%",
              textAlign: "center",
              height: "35px",
            }}
          >
            {data?._id ? "Applied" : "Draft"}
          </Typography>
          {/* NOTE: only show the delete button when the data is saved  */}
          {data?._id && user == "admin" && !data?.reimburseTechnician && (
            <CustomIconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Warning",
                    message: "Are you sure, you want to remove this charge?",
                    okLabel: "Delete",
                    onOk: () => {
                      dispatch(
                        removeReimbursementOrDeductionAction({
                          payload: {
                            params: { eventId },
                            data: {
                              ids: [
                                {
                                  id: data?._id,
                                },
                              ],
                            },
                          },
                        }),
                      );
                    },
                  }),
                );
              }}
            >
              <Delete sx={{ fontSize: "1.5rem" }} />
            </CustomIconButton>
          )}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: "transparent",
            border: `1px solid ${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })}`,
            borderTop: "none",
            borderRadius: "8px",
            padding: "1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "1rem",
            flexDirection: "column",
            overflowY: "auto",
            maxHeight: "65%",
            "& p": {
              fontSize: "1.2rem",
            },
            "@media(max-width: 600px)": {
              fontSize: "1rem",
            },
          }}
          className="custom-scroll-design"
        >
          {data?._id && (
            <Box
              sx={{
                padding: "1rem",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                }}
              >
                Non Taxable Charge ID: {data?._id || "N/A"}
              </Typography>
            </Box>
          )}

          {data?._id && canManageReimbursement && <Box sx={{ width: "100%", display: "grid", gap: 1 }}>
            {!editingCharge && <Button variant="outlined" disabled={savingReimbursement} onClick={() => { setEditingCharge(true); setChargeError(""); }}
              sx={{ color: "#fff", borderColor: "#D175B6", justifySelf: "start", textTransform: "none" }}>Edit charge</Button>}
            {editingCharge && <Alert severity="info">Update the actual amount charged to the client. Existing invoices keep their saved amounts; review a new invoice revision after saving. The technician reimbursement is saved separately.</Alert>}
          </Box>}

          {/* here */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              flexDirection: "column",
              gap: "0.25rem",
              paddingLeft: "1rem",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: "white",
                WebkitLineClamp: 1,
                width: "43%",
                fontWeight: "500",
              }}
            >
              Category*
            </Typography>
            <Autocomplete
              fullWidth
              freeSolo
              readOnly={!chargeFieldsEditable}
              options={
                nonTaxableCategories?.filter(
                  (item) => item?.nonTaxableCategoryType,
                ) || []
              }
              getOptionLabel={(option) => typeof option === "string" ? option : option?.nonTaxableCategoryType || ""}
              value={{
                nonTaxableCategoryType: values?.nonTaxableCategoryType || "",
              }}
              onInputChange={(_, newVal, reason) => {
                if (reason === "input") {
                  formik.setFieldValue("nonTaxableCategoryType", newVal);
                }
              }}
              onChange={(_, newVal) => {
                formik.setFieldValue(
                  "nonTaxableCategoryType",
                  typeof newVal === "string" ? newVal : newVal?.nonTaxableCategoryType || "",
                );
              }}
              componentsProps={{
                paper: {
                  style: {
                    display: "block",
                    background: "black",
                    outline: "1px solid white",
                    borderRadius: "8px",
                  },
                },
              }}
              onBlur={handleBlur}
              noOptionsText={"No Categories Available"}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="nonTaxableCategoryType"
                  placeholder="Type Here"
                  InputLabelProps={{
                    style: { color: "white" },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      paddingY: "7px !important",
                      "& fieldset": {
                        borderRadius: "8px",
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      "&:hover fieldset": {
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      },
                      color: "white",
                    },
                    "& .MuiInputBase-input": {
                      color: "white",
                    },
                    "& .MuiAutocomplete-popupIndicator": {
                      color: "white",
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {option.nonTaxableCategoryType}
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        alertDialogAciton({
                          open: true,
                          title: "Delete Category",
                          message:
                            "Are you sure you want to delete this category?",
                          onOk: () => {
                            dispatch(
                              removeReimbursementAndDeductionCategoriesAction({
                                payload: {
                                  params: {
                                    id: option?._id,
                                  },
                                },
                                successCallback: () => {
                                  dispatch(getDeductionCategoriesAction({}));
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Success",
                                      message: "Category Deleted Successfully.",
                                    }),
                                  );
                                },
                                failureCallback: () => {
                                  dispatch(
                                    alertDialogAciton({
                                      open: true,
                                      title: "Error",
                                      message: "Failed to delete category.",
                                    }),
                                  );
                                },
                              }),
                            );
                          },
                          okLabel: "Delete",
                        }),
                      );
                    }}
                  >
                    <Delete sx={{ color: "white", fontSize: "1.5rem" }} />
                  </IconButton>
                </li>
              )}
            />
            {touched.nonTaxableCategoryType && errors.nonTaxableCategoryType && (
              <Typography color={"red"} fontSize={"0.75rem"}>
                {errors.nonTaxableCategoryType}
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="date-select"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Date
              </Typography>
            </InputLabel>
            <Box
              sx={{
                width: "200px",
              }}
            >
              <CustomDatePicker
                variant="rounded"
                name="nonTaxableDate"
                sx={{
                  "& fieldset": {
                    borderColor: `${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} !important`,
                    borderWidth: "1.8px",
                  },
                  "& input": {
                    paddingY: "1rem !important",
                  },
                }}
                labelId="date-select"
                value={dayjs(values?.nonTaxableDate || "")}
                format={
                  values?.nonTaxableDate ? "ddd MM/DD/YYYY" : "MM/DD/YYYY"
                }
                onBlur={handleBlur}
                readOnly={!chargeFieldsEditable}
                onChange={(date) => {
                  formik.setFieldValue(
                    "nonTaxableDate",
                    date?.format("YYYY-MM-DD"),
                  );
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="amount-input"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                {/* Amount* */}
                Amount*
              </Typography>
            </InputLabel>

            <Box
              sx={{
                position: "relative",
              }}
            >
              <CustomInput
                labelId="amount-input"
                className="rate-input"
                name="nonTaxableAmount"
                sx={{
                  border: `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} `,
                  borderRadius: "8px",
                  fontSize: "16px",
                  width: "200px !important",
                  // "& fieldset": {
                  //   border: "none",
                  // },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })} !important`,
                  },
                }}
                type="number"
                fullWidth
                placeholder="00.00"
                onChange={handleChange}
                readOnly={!chargeFieldsEditable}
                onBlur={handleBlur}
                value={values?.nonTaxableAmount}
                startAdornment={
                  <InputAdornment position="start">
                    <Typography variant="h5" color="primary">
                      &#36;
                    </Typography>
                  </InputAdornment>
                }
              />
            </Box>
          </Box>
          {errors?.nonTaxableAmount && touched?.nonTaxableAmount && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.nonTaxableAmount}
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "0.5rem",
              color: "white",
              paddingLeft: "1rem",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <InputLabel
              sx={{
                color: "white",
                fontWeight: "500",
                fontSize: "1rem",
              }}
              id="nonTaxableNotes-input"
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "white",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Notes
              </Typography>
            </InputLabel>
            <TextField
              name="nonTaxableNotes"
              multiline
              rows={2}
              sx={{
                width: "100%",
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex",
                })}`,
                borderRadius: "8px",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: `${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })} !important`,
                },
                "& input, fieldset, textarea": {
                  color: "white",
                  fontSize: "16px",
                },
              }}
              onChange={handleChange}
              InputProps={{
                readOnly: !chargeFieldsEditable,
              }}
              onBlur={handleBlur}
              value={values?.nonTaxableNotes}
              placeholder="Add notes here"
            />
          </Box>
          {errors?.nonTaxableNotes && touched?.nonTaxableNotes && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
              }}
              color="error"
            >
              {errors?.nonTaxableNotes}
            </Typography>
          )}

          {chargeError && <Alert severity="error" sx={{ width: "100%" }}>{chargeError}</Alert>}
          {data?._id && editingCharge && <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="contained" disabled={savingCharge || !formik.dirty} onClick={submitForm}
              sx={{ color: "#fff", bgcolor: "#D175B6", textTransform: "none", "&:hover": { bgcolor: "#bd6aad" } }}>
              {savingCharge ? "Saving…" : "Save charge"}
            </Button>
            <Button variant="outlined" disabled={savingCharge} onClick={() => { formik.resetForm(); setEditingCharge(false); setChargeError(""); }}
              sx={{ color: "#fff", borderColor: "#D175B6", textTransform: "none" }}>Cancel</Button>
          </Box>}

          {canManageReimbursement && <>
            <ExpenseReimbursementFields eventId={eventId} value={reimbursement} clientAmount={values.nonTaxableAmount}
              disabled={savingReimbursement || ntLoading || editingCharge || savingCharge} error={reimbursementError}
              onChange={next => { setReimbursement(next); setReimbursementError(""); }} />
            {data?._id && <Button variant="contained" disabled={savingReimbursement || !reimbursementChanged || editingCharge || savingCharge}
              sx={{ color: "#fff", bgcolor: "#D175B6", minHeight: 40, px: 2, borderRadius: "5px", textTransform: "none",
                "&:hover": { bgcolor: "#bd6aad" },
                "&.Mui-disabled": { color: "rgba(255,255,255,.45)", bgcolor: "rgba(209,117,182,.15)", border: "1px solid rgba(209,117,182,.35)" } }}
              onClick={saveReimbursement}>
              {savingReimbursement ? "Saving…" : "Save reimbursement"}
            </Button>}
          </>}

          {canManageReimbursement && (data?._id
            ? <ExpenseReceiptManager eventId={eventId} chargeId={String(data._id)} />
            : <Typography variant="body2">Save this charge before uploading receipts.</Typography>)}

          {/* NOTE: a note to show this will be included in invoice  */}
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "1rem !important",
              fontWeight: "300",
              width: "100%",
              color: getCssVariableHandler({
                variableName: "--primary-green-text-hex",
              }),
            }}
          >
            This non-taxable charge will be added to the invoice.
          </Typography>

          {/* NOTE: buttons for request deduction */}
          <Box
            className="bottomButton"
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
              width: "100%",
              gap: "3rem",
              "@media(max-width: 600px)": {
                flexDirection: "column",
                gap: "0.5rem",
              },
            }}
          >
            {user == "admin" && !data?._id &&
              data?.reImbursementStatus?.toLowerCase() == "draft" && (
                <Button className="btnPink" onClick={submitForm} disabled={ntLoading}>
                  {ntLoading ? (
                    <CircularProgress />
                  ) : (
                    <Typography className="btn-text">Add charges</Typography>
                  )}
                </Button>
              )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

NonTaxableAcc.propTypes = {
  user: PropTypes.string,
  data: PropTypes.object,
  expanded: PropTypes.string,
  handleAccChange: PropTypes.func,
  sessionId: PropTypes.string,
  id: PropTypes.string,
  setData: PropTypes.func,
  isEditable: PropTypes.bool,
  status: PropTypes.string,
  index: PropTypes.number,
};
